module.exports = __webpack_public_path__ + "static/media/ProcessIcon.5ba300ae.svg";